import styled from '@emotion/styled';
import { Menu } from '@mui/material';
import { colors } from 'theme/colors';

const StyledMenu = styled(Menu)`
  & > .MuiPaper-root {
    border: 1px solid ${colors.blue200};
    filter: drop-shadow(0px 2px 4px rgba(194, 204, 243, 0.15))
      drop-shadow(0px 2px 4px rgba(194, 204, 243, 0.15))
      drop-shadow(0px 4px 4px rgba(194, 204, 243, 0.15))
      drop-shadow(0px 6px 6px rgba(194, 204, 243, 0.15));
    border-radius: 4px;
  }
`;

export { StyledMenu };
